import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCertificationInformationRes } from "core/http/service/personnelInformation/resTypes";
import { uniqueId } from "lodash";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: getCertificationInformationRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    certificates: [],
    certificateOthers: [],
  },
};

const getCertificationInformationSlice = createSlice({
  name: "getCertificationInformation",
  initialState,
  reducers: {
    getCertificationInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getCertificationInformationSuccess: (
      state,
      action: PayloadAction<getCertificationInformationRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      const { certificates } = action.payload;

      const certificateOthers = (action.payload.certificateOthers ?? []).map(
        (item) => ({
          ...item,
          certificateTypeLabel: item.certificateType,
          files: (item.files ?? []).map((file) => ({
            ...file,
            id: uniqueId(),
          })),
        })
      );
      state.data.certificates = (
        certificates ?? [
          {
            certificateCateCode: "",
            certificateType: "",
            practicingCertificateStatus: "",
            effectiveDate: null,
            certificateNo: "",
            issuedDate: null,
            file: "",
          },
        ]
      ).map((item) => ({
        ...item,
        practicingCertificateStatus: !!item.certificateCateCode ? 1 : 0,
      }));
      state.data.certificateOthers = certificateOthers;
    },
    getCertificationInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetCertificationInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getCertificationInformationStart,
  getCertificationInformationSuccess,
  getCertificationInformationFailed,
  resetCertificationInformation,
} = getCertificationInformationSlice.actions;

export default getCertificationInformationSlice.reducer;
